import { Feature } from '@sdk/common/features';
import gettext from '@sdk/lang/gettext';

import usePremiumGuard from '@web/premiumGuard/usePremiumGuard';

export const useGroupConversationsPremiumGuard = () => {
  const { getPremiumGuardConfig, openPremiumGuardModal, tooltipRefs } = usePremiumGuard();
  const premiumGuardConfig = getPremiumGuardConfig(Feature.groupMessages);
  const tooltipContent = !premiumGuardConfig.hasAccess
    ? gettext('Group conversations are available in %(requiredPlan)s. Click to learn more.', {
        requiredPlan: premiumGuardConfig.requiredPlan,
      })
    : '';

  return {
    areGroupConversationsEnabled: premiumGuardConfig.hasAccess,
    openPremiumGuardModal,
    premiumGuardConfig,
    tooltipRefs,
    tooltipContent,
  };
};
